import React from 'react';
import { Card, Spinner, Button } from 'react-bootstrap';

// Standard icon sizes
export const ICON_SIZES = {
  small: '2rem',
  medium: '3rem',
  large: '4rem'
};

// Standard padding for card bodies
export const CARD_PADDING = 'p-4';

/**
 * Standardized loading state component
 */
export const LoadingState = ({ message = "Loading...", size = "medium" }) => {
  return (
    <Card className="mb-4">
      <Card.Body className={`text-center ${CARD_PADDING}`}>
        <Spinner animation="border" variant="primary" className="mb-3" />
        <p className="mb-0">{message}</p>
      </Card.Body>
    </Card>
  );
};

/**
 * Standardized error state component
 */
export const ErrorState = ({ 
  message = "An error occurred. Please try again later.", 
  onRetry,
  size = "medium" 
}) => {
  return (
    <Card className="mb-4 border-danger">
      <Card.Body className={`text-center ${CARD_PADDING}`}>
        <div className="text-danger mb-3">
          <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: ICON_SIZES[size] }}></i>
        </div>
        <p className="mb-2">{message}</p>
        {onRetry && (
          <Button 
            variant="outline-primary" 
            size="sm"
            onClick={onRetry}
            className="mt-2"
          >
            Try Again
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

/**
 * Standardized success state component
 */
export const SuccessState = ({ 
  title, 
  message, 
  size = "medium",
  children
}) => {
  return (
    <Card className="mb-4 border-success">
      <Card.Body className={`text-center ${CARD_PADDING}`}>
        <div className="text-success mb-4">
          <i className="bi bi-check-circle-fill" style={{ fontSize: ICON_SIZES[size] }}></i>
        </div>
        {title && <h5 className="mb-3">{title}</h5>}
        {message && <p className="mb-4">{message}</p>}
        {children}
      </Card.Body>
    </Card>
  );
};

/**
 * Standardized cancel/failure state component
 */
export const CancelState = ({ 
  title, 
  message, 
  size = "medium",
  children
}) => {
  return (
    <Card className="mb-4">
      <Card.Body className={`text-center ${CARD_PADDING}`}>
        <div className="text-danger mb-4">
          <i className="bi bi-x-circle-fill" style={{ fontSize: ICON_SIZES[size] }}></i>
        </div>
        {title && <h5 className="mb-3">{title}</h5>}
        {message && <p className="mb-4">{message}</p>}
        {children}
      </Card.Body>
    </Card>
  );
};
